<template>
  <div class="_taskView__comment">
    <md-checkbox 
      v-show="isInternalGroupMember" 
      v-model="comment.internal"
    >Internal</md-checkbox>

    <TinyMceEditor
      v-model="comment.body" 
      theId="comment"
      :height="200"
      :mentionArr="userListItems" 
      :attachments="attachmentData"
      @itemSelected="commentItemSelected"
      @success="onUploadSuccess"
    />

    <div>
      <md-card-actions md-alignment="left" v-if="!attachmentData.length">
        <md-button class="md-simple md-just-icon _attachFileBtn">
          <i class="material-icons" v-on:click="onUpload()">attachment</i>
        </md-button>
        <span v-if="attachmentData == null">Browse or attach file here</span>
      </md-card-actions>
      <md-card-content v-if="attachmentData.length" class="attachment-area">
        <div class="md-layout">
          <md-card-actions md-alignment="left">
            <md-button class="md-simple md-just-icon _attachFileBtn">
            <i class="material-icons" v-on:click="onUpload()">attachment</i>
          </md-button>
          </md-card-actions>
          <div class="md-layout-item">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-large-size-20 md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-for="(attachment, chunkIndex) in attachmentData" v-bind:key="chunkIndex">
                <div v-show="attachment.file.name" class="attchment-card">
                  <div class="attchment-container">{{ attachment.file.name }} ({{ attachment.file.size | kb }} kb)
                    <button type="button" class="attachment-button" title="Remove" @click="removeFile(chunkIndex)" >x</button>
                  </div>
                  <!-- <md-checkbox 
                    class="attachment-area__checkbox" 
                    v-show="$Session && $Session.isInternalGroupMember"
                    v-model="isInternal"
                  >Internal</md-checkbox> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </md-card-content>
      <md-card-actions md-alignment="right">
        <md-button
          class="md-sm md-success"
          :disabled="!hasComment || isPromisePending"
          @click="onComment()"
        >
          <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">send</i>
          Submit
        </md-button>
        <md-button class="md-sm md-danger" :disabled="isPromisePending" @click="onClose">
          <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">close</i>
          Cancel
        </md-button>
      </md-card-actions>
    </div>
    <!-- Upload Dialog -->
    <md-dialog :md-active.sync="isUploadDialogOpen" class="_attachmentsDialog">
      <md-dialog-title>Attachment</md-dialog-title>
      <md-dialog-content>
        <CommentAttachmentsForm
          :docTypes="docTypes"
          :model="attachmentData"
          @success="onUploadSuccess"
        />
      </md-dialog-content>
    </md-dialog>
    <md-snackbar md-position="center" :md-active.sync="isSnackbarOpen" md-persistent>
      <span>{{ errorMsg }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import Amplify, { Auth, API, graphqlOperation } from "aws-amplify";
import * as mutations from "@/graphql/mutations";

import TinyMceEditor from "@/components/Editor/TinyMceEditor";
import CommentAttachmentsForm from '@/components/DynamicForm/Attachments/CommentAttachmentsForm';
import TaskMixin from "@/pages/Tasks/Mixins/TaskMixin";
import AttachmentMixin from '@/components/DynamicForm/Attachments/Mixins/AttachmentMixin';
const TaskPageMixin = {
  methods: {
    sendComment: TaskMixin.methods.sendComment,
    getUserList: TaskMixin.methods.getUserList,
    closeEditor: TaskMixin.methods.closeEditor,
    getAtMentionUsers: TaskMixin.methods.getAtMentionUsers,
    commentItemSelected: TaskMixin.methods.commentItemSelected,
  },
  data() {
    return {
      commentId: TaskMixin.data.commentId,
    }
  }
};

export default {
  mixins: [TaskPageMixin, AttachmentMixin],
  components: {
    TinyMceEditor,
    CommentAttachmentsForm,
  },
  props: {
    recordData: {
      type: Object,
      required: true,
    },
    atClose: {
      type: Function,
      required: true,
    },
    updateTaskComment: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      isBusy: false,
      comment: {
        body: "",
        internal: false,
      },
      errorMsg: "",
      // isSnackbarOpen: false,
      //the following are used by sendComment method imported from Task.vue
      userListItems: [],
      atMentionsCommentList: [],
      atMentionsUserList: [],
      isPromisePending: false,
    };
  },
  computed: {
    isInternalGroupMember() {
      return this.$reduce(this, "$Session.isInternalGroupMember");
    },
    hasComment() {
      return this.comment.body && this.comment.body.trim().length;
    },
  },
  mounted() {
    this.getUserList();
  },
  methods: {
    async onComment() {
      this.isPromisePending = true;
      const attachmentData = this.attachmentData
      const that = this;
      await this.sendComment()
        .then(() => {
          that.errorMsg = "Comment Added";
          that.isSnackbarOpen = true;
          
          if (attachmentData.length > 0) {
            console.log("Attachment Started");
            const newCommentId = that.commentId;
            const relations = [
              { fromModelType: 'Comment', relationCommentId: newCommentId },
              { fromModelType: 'Task', relationTaskId: that.recordData ? that.recordData.id : '' }
            ]
            
            if (that.recordData && that.recordData.case) {
              relations.push({ fromModelType: 'Case', relationCaseId: that.recordData.case.id })
            }
            
            // if (that.recordData && that.recordData.services && that.recordData.services.items) {
            //   for (const _service of that.recordData.services.items) {
            //     relations.push({ fromModelType: 'Service', relationServiceId: _service.id })
            //   }
            // }
            
            const serviceItems = this.$reduce(that, 'recordData.case.services.items') || [];
            for (let i = 0; i < serviceItems.length; i++) {
              const serviceId = this.$reduce(serviceItems, `${i}.service.id`);
              if (serviceId) {
                relations.push({ fromModelType: 'Service', relationServiceId: serviceId });
              }
            }

            console.log("Attachment ADD");
            that.attachments = attachmentData
            that.add(relations);
          }
          //ATLAS-1056: Set flag for comment added on checked task
          if (this.updateTaskComment) {
            this.updateTaskComment.skipTaskUpdate = false;
          }
          setTimeout(() => {
            this.isPromisePending = false;
            this.atClose();
          }, 2000);
        })
        .catch((err) => {
          this.errorMsg = "Something went wrong - please try again!";
          this.isPromisePending = false;
          this.isSnackbarOpen = true;
        });
    },
    onClose() {
      //ATLAS-1056: Set flag for comment added on checked task
      if (this.updateTaskComment) {
        this.updateTaskComment.skipTaskUpdate = false;
      }
      this.closeEditor("comment");
      this.atClose();
    },
    removeFile(fileIndex){
      this.attachmentData.splice(fileIndex, 1)
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
